import { memo, useState } from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../../theme/palette";
import { OWNERSHIP } from "../../../consts/strings";
import { RouteLabel } from "../../Layers/RouteLabelLayer/RouteLabel";
import { View } from "../../Base";
import { PickupPopup } from "../../SearchBar/PickupPopup";

const useStyles = makeStyles({
  rowContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.7rem",
    gap: "1rem",
  },
  partnerContainer: {
    height: "1.6rem",
    display: "flex",
  },
  labelContainer: {
    width: "10rem",
    textAlign: "right",
    margin: "0.1rem 1rem 0rem 0rem",
  },
  toggleContainer: {
    display: "flex",
    width: "5.2rem",
    borderRadius: "0.8rem",
    boxShadow: "rgb(0 0 0 / 50%) 0px 1px 4px",
    cursor: "pointer",
  },
  toggleCircle: {
    background: palette.white,
    margin: "0.05rem 0.15rem",
    height: "1.5rem",
    width: "1.5rem",
    borderRadius: "50%",
    boxShadow: "rgb(0 0 0 / 80%) 0px 1px 4px",
  },
  toggleValueLabelContainer: {
    display: "flex",
    flex: 1,
    padding: "0.1rem 0.3rem",
    pointerEvents: "none",
    userSelect: "none",
  },
  toggleFullValueLayout: {
    flexDirection: "row-reverse",
  },
  routeLabelContainer: {
    width: "86px",
    display: "flex",
    justifyContent: "center",
  },
  routeLabelGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    minHeight: "30px",
  },
  spacing: {
    padding: "2px",
  },
});

export const EditPickupPartnerRow = memo(
  ({ routeEdit, label, value, config, onEdit }) => {
    const styles = useStyles();
    const [anchorEl, setAnchorEl] = useState();

    const { routeCodes, popupLabels } = config;
    const toggleBackgroundStyles = {
      [OWNERSHIP.ALL]: { background: routeEdit.colour },
      [OWNERSHIP.SOME]: {
        background: `repeating-linear-gradient(135deg, ${routeEdit.colour} 0px, ${routeEdit.colour} 10px, ${palette.veryLightGrey} 10px, ${palette.veryLightGrey} 20px)`,
      },
      [OWNERSHIP.NONE]: { background: palette.veryLightGrey },
    };

    return (
      <View>
        <View className={styles.rowContainer}>
          <View className={styles.partnerContainer}>
            <View className={styles.labelContainer}>{`${label}:`}</View>
            <View
              className={clsx(
                styles.toggleContainer,
                value === OWNERSHIP.ALL && styles.toggleFullValueLayout
              )}
              style={toggleBackgroundStyles[value]}
              onClick={onEdit}
            >
              <View className={styles.toggleCircle} />
              <View
                className={clsx(
                  styles.toggleValueLabelContainer,
                  value === OWNERSHIP.ALL && styles.toggleFullValueLayout
                )}
              >
                <View>{value.toLowerCase()}</View>
              </View>
            </View>
          </View>

          <View
            className={styles.routeLabelContainer}
            onClick={(e) => {
              e.stopPropagation();
              const routesCount = Object.keys(popupLabels).length;
              setAnchorEl(!anchorEl && routesCount ? e.currentTarget : null);
            }}
          >
            <View>
              <Grid container className={styles.routeLabelGrid}>
                {routeCodes.length > 6 ? (
                  <Grid
                    item
                    container
                    xs
                    className={clsx(styles.spacing)}
                    direction={"row"}
                  >
                    <RouteLabel routeCode={"M"} />
                  </Grid>
                ) : (
                  routeCodes.map((routeCode, index) => (
                    <Grid
                      key={index}
                      item
                      container
                      xs={routeCodes.length >= 3 ? 4 : 12 / routeCodes.length}
                      className={clsx(styles.spacing)}
                      direction={"row"}
                    >
                      <RouteLabel routeCode={routeCode} />
                    </Grid>
                  ))
                )}
              </Grid>
            </View>
          </View>
        </View>
        <PickupPopup
          anchorEl={anchorEl}
          pickupConfig={config}
          onClose={() => setAnchorEl(null)}
        />
      </View>
    );
  }
);
